import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SettingsService } from '../../service/settings.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CommentsService } from '../../service/comments.service';
import { TranslateService } from '@ngx-translate/core';
import { deepCopy, makeid } from 'na-lib';
import { ContentType } from 'na-lib';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { defaultFieldsDSection } from 'na-lib';
import { TaskTemplateEditSectionDialogComponent } from '../../worktask/worktask-template-edit-section-dialog/worktask-template-edit-section-dialog.component';
import { ContentTypeDisplayTemplateFieldDialogComponent } from '../content-type-display-template-field-dialog/content-type-display-template-field-dialog.component';
import { ReportService } from '../../service/report.service';
import { ConfirmChangesDialogComponent } from '../../confirm-changes-dialog/confirm-changes-dialog.component';

@Component({
    selector: 'app-content-type-display-template-dialog',
    templateUrl: './content-type-display-template-dialog.component.html',
    styleUrls: ['./content-type-display-template-dialog.component.css'],
    standalone: false
})
export class ContentTypeDisplayTemplateDialogComponent {

  oldData:any
  allSections:any = []
  routerUrl:any
  idToShow:any
  contenttype:ContentType
  contentData:any
  displaySectionsData:any
  contentTypeUserRights_update:any
  contentTypeUserRights_delete:any
  displaySectionsForm!:FormGroup
  phoneFullHeightView = false;
  allIds:any=[]
  allKeys:any = []
  addedFields:any = 0
  duplicateKeys = false
  allTaskTemplates:any = []
  fieldTypeTitles: { [key: string]: string } = {
    boolean: 'Boolean Field',
    currency: 'Currency Field',
    dateTime: 'DateTime Field',
    time: 'Time Field',
    date: 'Date Field',
    decimal: 'Decimal Field',
    longText: 'Long Text Field',
    number: 'Number Field',
    text: 'Text Field',
    weight: 'Weight Field',
    document: 'Document / Image Field',
    showImage: 'Display Image Field'
  };

  elementsOptions = [
    {
      name: 'text',
      icon:'text_format',
      translations:'taskTemplates.add_text',
      type:'text'
    },
    {
      name: 'longText',
      icon:'subject',
      translations:'taskTemplates.add_longText',
      type:'longText'
    },
    {
      name: 'number',
      icon:'pin',
      translations:'taskTemplates.add_number',
      type:'number'
    },
    {
      name: 'decimal',
      icon:'numbers',
      translations:'taskTemplates.add_decimal',
      type:'decimal'
    },
    // currency is also commented out in Tracer Templates (worktask-template-item.component.ts), if we need it - need to be uncommented in both files
    // {
    //   name: 'currency',
    //   icon:'euro',
    //   translations:'taskTemplates.add_currency',
    //   type:'currency'
    // },
    {
      name: 'date',
      icon:'calendar_today',
      translations:'taskTemplates.add_date',
      type:'date'
    },
    {
      name: 'time',
      icon:'access_time',
      translations:'taskTemplates.add_time',
      type:'time'
    },
    {
      name: 'dateTime',
      icon:'calendar_month',
      translations:'taskTemplates.add_dateTime',
      type:'dateTime'
    },
    {
      name: 'boolean',
      icon:'toggle_on',
      translations:'taskTemplates.add_switch',
      type:'boolean'
    },
    {
      name: 'weight',
      icon:'weight',
      translations:'taskTemplates.add_weight',
      type:'weight'
    },
    {
      name: 'document',
      icon:'attach_file',
      translations:'taskTemplates.add_doc',
      type:'document'
    },
    {
      name: 'showImage',
      icon:'image',
      translations:'taskTemplates.add_showImage',
      type:'showImage'
    }

  ]

  savedData = true

  constructor(
    public dialog: MatDialog,
    private settingsService: SettingsService,
    private reportService: ReportService,
    private fb: FormBuilder,
    private commentService: CommentsService,
    private translate:TranslateService,
    public dialogRef: MatDialogRef<ContentTypeDisplayTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any[],){
  }

  ngOnInit(){
    this.idToShow = this.data['id']
    this.contentData = deepCopy(this.data['contentType'])

    this.displaySectionsForm = this.fb.group({
      sections:[],
    })

    if(this.contentData){
      this.contenttype = new ContentType()
      this.contenttype.setFromAny(this.contentData)
      this.oldData = deepCopy(this.contentData)

      if(this.contenttype.displaySections){
        this.displaySectionsData = this.contenttype.displaySections
        if(this.displaySectionsData)
          this.allSections=this.displaySectionsData
        else
          this.allSections=[]

        this.initializeForm()
      }else{
        this.initializeDefaultForm()
      }

    }else{
      this.getContentTypeId()
    }

    this.contentTypeUserRights_update = this.settingsService.modulesRolesRights$.value['contentTypes']['U']
    this.contentTypeUserRights_delete = this.settingsService.modulesRolesRights$.value['contentTypes']['D']

    this.settingsService.modulesRolesRights$.subscribe( value => {
      this.contentTypeUserRights_update = this.settingsService.modulesRolesRights$.value['contentTypes']['U']
      this.contentTypeUserRights_delete = this.settingsService.modulesRolesRights$.value['contentTypes']['D']
    })

    this.displaySectionsForm.valueChanges.subscribe(value => {
      this.savedData = false
    })

    this.displaySectionsForm.get('sections')?.valueChanges.subscribe(value => {
      this.checkDuplicatesKeys()
    })

    this.loadTaskTemplates()
  }

  loadTaskTemplates(){
    this.settingsService.observeContextsWorkTasksTemplatesFirestoreWithId().subscribe(templates => {
      this.allTaskTemplates = templates
    })
  }


  initializeForm(){
    const {displaySections} =  this.contenttype
    this.displaySectionsForm.patchValue({ sections: displaySections ? displaySections : [] })
  }

  initializeDefaultForm(){
    this.allSections = []
    this.displaySectionsForm.patchValue({ sections: [] })
  }

  drop(event: CdkDragDrop<string[]>, index:number) {

    moveItemInArray(this.allSections[index].fields, event.previousIndex, event.currentIndex);
    this.updateSections()
  }

  dropPanel(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.allSections, event.previousIndex, event.currentIndex);
    this.updateSections();
  }

  addFieldToSection(fieldType, section){
    const id= makeid(6)
    const _defaultFields = defaultFieldsDSection
    if(!this.allIds.includes(id)){
      this.allIds.push(id)
    }
    const newField = deepCopy(_defaultFields[fieldType])
    newField['id']=id
    const fieldTitle = this.fieldTypeTitles[fieldType] || 'New Field';
    newField['title'] = `${fieldTitle} ${this.addedFields}`;
    newField['key']+=''+this.addedFields
    if(this.allKeys.includes(newField['key'])){
      const random = makeid(4)
      newField['key']+=''+ random
      newField['title']+=''+random
    }
    this.addedFields++;
    this.allSections[section].fields.push(newField)
    this.allKeys.push(newField.key)
    this.updateSections()
  }

  async getContentTypeId(){
    try{
      this.commentService.progressSpin.emit(true)
      const ct = await this.settingsService.observeContextsContentTypesIdFirestore(this.idToShow)
      this.contenttype = new ContentType
      this.contenttype.setFromAny(ct)
      this.contentData= new ContentType
      this.contentData.setFromAny(ct)

      if(!this.contentData['id']){
        this.contentData['id']= this.idToShow
      }

      this.commentService.progressSpin.emit(false)

    }catch(error){
      console.log(error)
      this.commentService.progressSpin.emit(false)
      const message = this.translate.instant("SnackBarConstants.LOAD_FAILED")
      this.commentService.addSnackBar.emit(message)

    }
  }

  editTitleSection(title, index){
    let dialogRef= this.dialog.open(TaskTemplateEditSectionDialogComponent, {
      data: {
          values: title
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result[1]){
        this.allSections[index].title = result[0].title
        this.updateSections()
      }
    });

  }

  duplicateSection(section, index){
    const newSection = deepCopy(section)

    if(newSection.fields){
      newSection.fields.forEach((field, index) => {
        field.id = makeid(6)
        this.allIds.push(field.id)
        field.key += '_copy'
        this.allKeys.push(field.key)
      });
    }
    if(newSection.title)
      newSection.title += '_copy'
    newSection.id = deepCopy(makeid(6))
    this.allSections.push(newSection)
    this.updateSections()
  }

  deleteSection(title, index){
    this.allSections.splice(index,1)
    this.updateSections()
  }

  openFieldDialog(item, fieldNumber, index){
    let dialogRef= this.dialog.open(ContentTypeDisplayTemplateFieldDialogComponent, {
      data: {
          values: item
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result[0]){
        this.allSections[index].fields[fieldNumber] = result[1]
        this.updateSections()
      }
    });
  }

  deleteFieldOfSection(fieldNumber, indexSection){
    this.allSections[indexSection].fields.splice(fieldNumber,1)
    this.updateSections()
  }

  addSection(){
    const title = this.translate.instant('workTask.newSection')
    const nuevo = {
      title: title,
      fields: [],
      id: ''
    }
    nuevo.id = deepCopy(makeid(5))
    this.allSections.push(nuevo)
    this.updateSections()
  }

  checkDuplicatesKeys(){
    let allFieldsNumber = 0
    this.allIds=[]
    this.allKeys=[]
    let changes = false
    this.duplicateKeys = false

    this.allSections.forEach((section, index) => {
      if(section.fields ){
        section.fields.forEach( (field, number) => {
          if(field.id){
            if(this.allIds.includes(field.id)){
              field.id = makeid(6)
              changes = true
              this.allIds.push(field.id)
            }else{
              this.allIds.push(field.id)
            }
          }

          if(field.key){
            allFieldsNumber++
            this.addedFields = allFieldsNumber
            if(this.allKeys.includes(field.key)){
              this.duplicateKeys = true
              this.allKeys.push(field.key)
            }else{
              this.allKeys.push(field.key)
            }
          }else{
            if(field.key==""){
              if(this.allKeys.includes(field.key)){
                this.duplicateKeys = true
                this.allKeys.push("")
              }else{
                this.allKeys.push("")
              }
            }
          }
        })
      }
    });

    if(changes){
      this.updateSections()
    }
  }

  async createReportTemplate(){
    if(this.savedData){
      this.commentService.progressSpin.emit(true)
      let reportData = {
        displayName : this.contenttype.displayName,
        contentTypeId: this.contenttype.id,
        resultFields: [],
        filters:[]
      }
      const data = deepCopy(this.displaySectionsForm.value.sections)
      if(data){
        let columns = []
        data.forEach(section => {
          if(section.fields){
            const fields = section.fields
            fields.forEach(field => {
              const type = field.type
              if(type){
                if(type=='weight'){
                  field.type = 'number'
                  field.key += '.value'
                }

                if(type == 'text' || type == 'currency' || type == 'options' || type == 'longText'){
                  field.type = 'string'
                }
                let newField = {
                  displayName : field.title,
                  key: field.key,
                  type:field.type
                }
                columns.push(newField)
              }

            });
          }
        });
        reportData.resultFields = columns
      }

      try{
        const a = await this.reportService.createReport(reportData, this.settingsService.contextId$)
        if(a){
          this.commentService.progressSpin.emit(false)
          const message = this.translate.instant( "SnackBarConstants.REPORT_CREATED_SUCCESS")
          this.commentService.addSnackBar.emit(message)
        }else{
          this.commentService.progressSpin.emit(false)
          const message = this.translate.instant( "SnackBarConstants.CREATE_WORK_TASK_FAILED")
          this.commentService.addSnackBar.emit(message)
        }

      }catch(error){
        this.commentService.progressSpin.emit(false)
        const message = this.translate.instant( "SnackBarConstants.CREATE_WORK_TASK_FAILED")
        this.commentService.addSnackBar.emit(message)
      }

    }else{
      const message = this.translate.instant( "SnackBarConstants.SAVE_CHANGES_FIRST")
      this.commentService.addSnackBar.emit(message)
    }
  }

  displayFieldTypes = Object.keys(defaultFieldsDSection)

  mapTaskFieldTypeToDisplayType(type: string): string | null {
    if (this.displayFieldTypes.includes(type)) {
      return type
    }
    switch (type) {
      case 'options': return 'text'
      case 'barcode': return 'text'
      case 'showText': return 'text'
      case 'document': return 'document'
      case 'showImage': return 'showImage'
      default: return null
    }
  }

  importFromTracerTemplate(taskTemplate: any){
    if (this.allSections.length > 0) {
      const dialogRef = this.dialog.open(ConfirmChangesDialogComponent, {
        data: {
          title: 'contentTypes.importFromTracerTemplate',
          message: 'contentTypes.importReplace'
        }
      })
      dialogRef.afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.doImport(taskTemplate)
        }
      })
      return
    }
    this.doImport(taskTemplate)
  }

  doImport(taskTemplate: any){
    const formSections = taskTemplate.formSections
    if (!formSections || formSections.length === 0) {
      const message = this.translate.instant('contentTypes.noTracerTemplates')
      this.commentService.addSnackBar.emit(message)
      return
    }

    const importedSections = []
    formSections.forEach(section => {
      const newSection = {
        title: section.title || section.titles?.de || 'Section',
        fields: [],
        id: makeid(5)
      }

      if (section.fields) {
        section.fields.forEach(field => {
          const mappedType = this.mapTaskFieldTypeToDisplayType(field.type)
          if (mappedType) {
            const newField = {
              id: makeid(6),
              key: field.payloadKey || field.key || '',
              title: field.title || '',
              type: mappedType
            }
            newSection.fields.push(newField)
          }
        })
      }

      importedSections.push(newSection)
    })

    this.allSections = importedSections
    this.updateSections()
    this.checkDuplicatesKeys()

    const message = this.translate.instant('contentTypes.importSuccess')
    this.commentService.addSnackBar.emit(message)
  }


  onSave(){
    if (this.hasEmptySections()) {
      const message = this.translate.instant('contentTypes.emptySectionsCannotBeSaved')
      this.commentService.addSnackBar.emit(message)
      return
    }
    const data = deepCopy(this.displaySectionsForm.value.sections)
    this.savedData = true
    this.dialogRef.close([true, data])
  }

  onCancel(){
    this.dialogRef.close([false, this.oldData])
  }

  private updateSections(): void {
    this.savedData = false
    this.displaySectionsForm.patchValue({ sections: this.allSections })
  }

  hasEmptySections(): boolean {
    return this.allSections.some(section => !section.fields || section.fields.length === 0)
  }

}
